export const configForecastRegionDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "%expo_map_url%/vector_tile/JMA_JMAFK_PLYGN/Line_%z%_%y%_%x%.json",
    "cache": true,
    "download_max": 64,
    "Grid" : {
      "MinZoom" : 3,
      "MaxZoom" : 7,
      "BoundingBox" : {
        "West":120.0,
        "South":20.0,
        "East":150.0,
        "North":50.0
      }
    }
  }
}

export const configForecastRegionLayer = {
  "Name" : "PrefectureForecastRegion",
  "Renderer" : "GeoJSON",
  "Attributes" : {
    "features" : [
      {
        "style" : {
          "default" : {
            "type" : "Polygon",
            "line_color" : "#000",
            "line_width" : 1
          },
          "dark": {
            "type" : "Polygon",
            "line_color" : "#FFA500",
            "line_width" : 1
          }
        }
      }
    ]
  }
}
